import React from "react";
import ReactDOM from "react-dom";

import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import "./index.css";
import App from "./app/App";
import * as serviceWorker from "./serviceWorker";

import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import config from "./config";
import { PredefinedColor } from "meet-addons-sdk";

Sentry.init({
  dsn:
    "https://d3aad1377f42414bba6675fbb9e1fc9f@o327792.ingest.sentry.io/5456604",
  integrations: [new Integrations.BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});


config.me = window.vivani.me;
config.meet = window.vivani.meet;
config.token = window.vivani.token;

var lastVisitDate = localStorage.getItem("meet-last-visit");
if (lastVisitDate) {
  config.lastVisitDate = new Date(JSON.parse(lastVisitDate));
}

localStorage.setItem("meet-last-visit", JSON.stringify(Date.now()));

const theme = createMuiTheme({
  palette: {
    type: "light",
    secondary: {
      main: "#00a152",
    },
  },
});

const Root = (
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);

ReactDOM.render(Root, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

declare global {

  interface IMe {
    avatarUrl: string;
    color: PredefinedColor;
    email: string;
    familyName: string;
    firstName: string;
    isAuthenticated: boolean;
    isGuest: boolean;
    provider: string;
    theme: string;
  }

  interface IHostConfig {
    auth: string;
    api: string;
    cdn: string;
    web: string;
    tx: string;
    xp: string;
  }

  interface IMeetConfig {
    hosts: IHostConfig;
  }

  interface ITokenInfo {
    value: string;
    expireAt: number;
  }

  interface IVivani {
    me?: IMe;
    meet: IMeetConfig;
    token?: ITokenInfo;
    ctx: IContext;
  }

  interface IContext {
    quickConfigurationId: string;
  }

  // tslint:disable-next-line:interface-name
  interface Window {
    vivani: IVivani;
  }
}
